import { useId } from 'react'
import Stack from '@mui/material/Stack'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'
import { PlanUsageCurrentPlanCard } from './PlanUsageCurrentPlanCard'
import { PlanUsageUpgradePlanCard } from './PlanUsageUpgradePlanCard'

export default function PlanUsagePlanAndUpgradeRow() {
  const headingId = useId()
  const intro = getSettingsSectionIntro('plan-subscription')

  return (
    <Stack component="section" aria-labelledby={headingId} spacing={1.25} className={shared.preferenceSection} sx={{ width: '100%', mt: '14px', alignItems: 'stretch' }}>
      {intro ? <SettingsSectionIntro headingId={headingId} lines={intro} /> : null}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} useFlexGap sx={{ width: '100%', alignItems: 'stretch' }}>
        <PlanUsageCurrentPlanCard />
        <PlanUsageUpgradePlanCard />
      </Stack>
    </Stack>
  )
}
